<template lang="html">
  <div
    class="fixed top-0 right-0 p-4 z-50 transition-opacity duration-300"
    :class="{ 'opacity-100': total > 0, 'opacity-0': total == 0 }"
  >
    <router-link class="btn-container" :to="{ name: 'cart' }">
      <div class="btn active">Cart</div>
      <div class="btn action">{{ total }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  computed: {
    total() {
      return this.$store.getters["totalItems"];
    },
  },
};
</script>
